export default (str: string): string => str?.replace(/[^\d]/g, '') || '';
